import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { LookupOptionsData } from '../../jurisdiction.domain';
import { AllDropdownKeys } from '../../jurisdiction.constants';
import { CommonService } from 'src/app/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TechnicianDataService } from '../technician-data.service';

@Component({
  selector: 'app-connection-type',
  templateUrl: './connection-type.component.html',
  styleUrls: ['./connection-type.component.scss'],
})
export class ConnectionTypeComponent implements OnInit {
  showPowerConnectionInfo1 = this.environmentService.showPowerConnectionInfo1;
  showPowerConnectionInfo2 = this.environmentService.showPowerConnectionInfo2;
  powerConnectionTypeKey = AllDropdownKeys.PowerConnectionType;
  powerConnectionTypes: LookupOptionsData[] = this.commonService.getDropdownData(this.powerConnectionTypeKey);

  form: FormGroup;

  @Input() set data(value: any) {
    if (!this.form || !value) return;

    this.form.patchValue({
      powerConnectionType: value.connectionType,
    });
  }
  @Input() isReadOnly: boolean;

  constructor(
    private environmentService: EnvironmentService,
    private commonService: CommonService,
    private technicianDataService: TechnicianDataService
  ) {
    this.form = new FormGroup({
      powerConnectionType: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(_ => {
      this.emitFormData();
    });

    this.emitFormData();
  }

  private emitFormData(): void {
    this.technicianDataService.registerForComponentFormUpdate.next({
      component: 'connectionTypeData',
      formData: this.form,
    });
  }
}
